import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AllRoutes } from 'constants/routes';
import { useEntitiesTable } from 'hooks/useEntitiesTable';
import { actions } from 'core/redux/api/veta/tep/entry-passes';
import { entryPassesSelector } from 'core/redux/selectors/tep';
import { useTepEntryPassesColumns } from './useTepEntryPassesColumns';

export const useTepDevicesTable = () => {
  const dispatch = useDispatch();

  const [isDevicesModal, setDevicesModal] = useState<boolean>(false);

  const {
    page,
    pageSize,
    sort,
    search,
    searchParams,
    columnsSorting,
    updatePage,
    updatePageSize,
    sortColumnData,
    searchHandler,
  } = useEntitiesTable(AllRoutes.TepDevicesManagement);

  const { request, data } = useSelector(entryPassesSelector);

  const columns = useTepEntryPassesColumns();

  const pageData = { no: page, size: pageSize.value, sort, search: search || undefined };

  const closeModal = () => setDevicesModal(false);

  const openModal = () => setDevicesModal(true);

  const fetchEntryPasses = () => {
    dispatch(actions.load.request({ payload: pageData }));
  };

  const addEntryPasses = (uris: string[]) => {
    dispatch(actions.add.request({ uris }));
    closeModal();
  };

  const controlProps = { search, searchHandler, openModal };

  const tableProps = {
    isLoading: request.isLoading,
    data: data?.objects || [],
    columns,
    columnsSorting,
    sortColumnData,
  };

  const footerProps = {
    totalCount: data?.total || 0,
    pageSize,
    page,
    onPageChange: updatePage,
    updatePageSize,
  };

  useEffect(() => {
    fetchEntryPasses();
  }, [searchParams]);

  useEffect(() => {
    if (data?.objects?.length === 0 && page !== 1) {
      updatePage({ selected: page - 1 });
    }
  }, [data?.objects]);

  return { isDevicesModal, controlProps, tableProps, footerProps, closeModal, addEntryPasses };
};
